// src/pages/garanties/HeroSection.jsx
import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import femmeVelo from "../../assets/femme-velo3.png";

import icon1 from "../../assets/icones/mobiliti_1_yellow.svg";
import icon2 from "../../assets/icones/mobiliti_2_yellow.svg";
import icon3 from "../../assets/icones/mobiliti_6_yellow.svg";
import icon4 from "../../assets/icones/hero_crevaison_icon_2_yellow.svg";
import icon5 from "../../assets/icones/mobiliti_4_yellow.svg";

const HeroSection = ({ onScrollClick }) => {
  const { t } = useTranslation("garanties/HeroSection");
  const navigate = useNavigate();

  const iconData = [
    { icon: icon1, title: t("icons.breakage.title"), subtitle: t("icons.breakage.subtitle") },
    { icon: icon2, title: t("icons.breakdown.title"), subtitle: t("icons.breakdown.subtitle") },
    { icon: icon3, title: t("icons.oxidation.title"), subtitle: t("icons.oxidation.subtitle") },
    { icon: icon4, title: t("icons.puncture.title"), subtitle: t("icons.puncture.subtitle") },
    { icon: icon5, title: t("icons.theft.title"), subtitle: t("icons.theft.subtitle") },
  ];

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5, px: 2 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 4, md: 3 },
          backgroundColor: "#449F2D",
          position: "relative",
          fontFamily: "'Poppins', sans-serif",
          overflow: "hidden",
          "@media (max-width:1270px)": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          },
        }}
      >
        {/* espace pris par l'illu à droite (desktop) */}
        <Box
          sx={{
            display: { xs: "none", md: "block" },
            width: { md: "300px", lg: "400px" },
            float: "right",
            height: "1px",
            "@media (max-width:1270px)": { display: "none" },
          }}
        />

        <Box sx={{ zIndex: 2 }}>
          <Typography
            gutterBottom
            sx={{
              color: "#fff",
              fontWeight: 900,
              fontSize: { xs: "2.2rem", md: "4rem" },
              lineHeight: 1.2,
              maxWidth: { xs: "100%", md: "65%" },
              mx: { "@media (max-width:1270px)": "auto" },
            }}
          >
            <Box component="span">{t("title.part1")} </Box>
            <Box component="span" sx={{ color: "#204B15" }}>
              {t("title.highlight")}
            </Box>{" "}
            {t("title.part2")}
          </Typography>

          <Typography
            sx={{
              color: "#fff",
              fontWeight: 600,
              fontSize: "1.200rem",
              mt: 2,
              mb: 4,
              maxWidth: { xs: "100%", md: "600px" },
              mx: { "@media (max-width:1270px)": "auto" },
            }}
          >
            {t("subtitle")}
          </Typography>

          {/* icônes */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "flex-start", "@media (max-width:1270px)": "center" },
              gap: 3,
              mb: 3,
            }}
          >
            {iconData.map((item, index) => (
              <Box key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: 110 }}>
                <Box component="img" src={item.icon} alt={item.title} sx={{ height: 50, mb: 0.5 }} />
                <Typography sx={{ color: "#fff", fontSize: "0.85rem", fontWeight: 600, textAlign: "center" }}>
                  {item.title}
                </Typography>
                {item.subtitle && (
                  <Typography sx={{ color: "#fff", fontSize: "0.7rem", fontWeight: 400, textAlign: "center", mt: 0.2 }}>
                    {item.subtitle}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>

          {/* CTA + Accéder à mon espace */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "flex-start", "@media (max-width:1270px)": "center" },
              mt: 2,
            }}
          >
            <Button
              onClick={onScrollClick}
              variant="contained"
              sx={{
                backgroundColor: "#fff",
                color: "#449F2D",
                fontWeight: 600,
                textTransform: "none",
                borderRadius: "999px",
                px: 2,
                py: 0.5,
                fontSize: "0.95rem",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                  transform: "scale(1.05)",
                  transition: "all 0.2s ease-in-out",
                },
              }}
            >
              {t("cta")}
            </Button>

            <Button
              onClick={() => navigate("/login")}
              variant="outlined"
              sx={{
                borderColor: "#fff",
                color: "#fff",
                fontWeight: 700,
                textTransform: "none",
                borderRadius: "999px",
                px: 2,
                py: 0.5,
                fontSize: "0.95rem",
                "&:hover": {
                  borderColor: "#fff",
                  backgroundColor: "rgba(255,255,255,0.15)",
                },
              }}
            >
              {t("ctaLogin")}
            </Button>
          </Box>
        </Box>

        {/* illustration droite (desktop) */}
        <Box
          component="img"
          src={femmeVelo}
          alt="Femme avec vélo"
          sx={{
            position: "absolute",
            bottom: -170,
            right: -20,
            height: "700px",
            display: "block",
            zIndex: 1,
            objectFit: "contain",
            pointerEvents: "none",
            "@media (max-width:1270px)": { display: "none" },
          }}
        />
      </Paper>
    </Box>
  );
};

export default HeroSection;